import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { getProcessApproval } from "../action/common/freshmanApprovalActionCreator";
import { emailVerificationStatus } from "../constants/emailVerificationStatus";
import { IFreshmanProcessApprove } from "../models/common/IFreshmanProcessApproval";
import LoaderSpinner from "./loader";

const FreshmanProcessApproval = (props: IFreshmanProcessApprove) => {
  const [responseMessage, setResponseMessage] = useState<string>("");
  const { getProcessApproval, response } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const getToken = async () => {
    if (!token) return;
    setIsLoading(true);
    await getProcessApproval(token);
  };
  
  useEffect(() => {
    getToken();
  }, [token, getProcessApproval]);
  
  useEffect(() => {
    if (response) {
      setResponseMessage(response);
      setIsLoading(false);
    }
  }, [response]); 

  useEffect(() => {
    const mainTag = document.querySelector("main");
    if (mainTag) {
      mainTag.classList.add("main-login");
    }
    return () => {
      if (mainTag) {
        mainTag.classList.remove("main-login");
      }
    };
  }, []);
  
  return (
    <div
      className="notificationwrap d-flex align-items-center justify-content-center"
      style={{ width: "100%", height: "90vh" }}
    >
      {isLoading ? (
        <LoaderSpinner />
      ) : responseMessage ? (
        <section className="notify-content">
          {responseMessage === emailVerificationStatus.Approved ? (
            <div className="notify-wrap notify-success">
              <img src="assets/images/success.png" alt="" />
              <h5>Successfully Enrolled!</h5>
              <span>The student's application has been successfully accepted. You may now proceed with further actions.</span>
            </div>
          ) : responseMessage === emailVerificationStatus.Rejected ? (
            <div className="notify-wrap notify-expired">
              <img src="assets/images/rejected.png" alt="" />
              <h5>Application Rejected!</h5>
              <span>The student's application has been rejected.</span>
            </div>
          ) : responseMessage === emailVerificationStatus.Error ||
            responseMessage === emailVerificationStatus.Invalid_Token ? (
            <div className="notify-wrap notify-expired">
              <img src="assets/images/expired.png" alt="" />
              <h5>Link Expired!</h5>
              <span>Oops! This link has expired or is no longer available.</span>
            </div>
          ) : null}
        </section>
      ) :  <LoaderSpinner />}
    </div>
  );
   
};

const mapDispatchToProps = {
  getProcessApproval: (token: string) => getProcessApproval(token),
};

function mapStateToProps(state: any) {
  return {
    response: state.common.freshmanProcessResponse,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreshmanProcessApproval);